import { SideOverHeaderNew, SideOverHeading } from '../../../../UI';
import { useTotalTermElementDetailViewSummaryPage } from '../hooks';
import { EmptyDebtIllustration } from '../../../../assets/EmptyDebtIllustration';
import { useLocation } from '@remix-run/react';
import { useClientContext } from '../../../../ClientContext';
import {
  appendQuarterlyProgressReportReturnTo,
  getSafeQuarterlyProgressReportReturnTo,
} from '../../../../QuarterlyProgressReport';

interface SummaryPageContainerProps {
  heading: string;
  emptyDescription: string;
  children: React.ReactNode;
}

export function SummaryPageContainer({ children, heading, emptyDescription }: SummaryPageContainerProps) {
  const { tCommon, withHeaderShadow } = useTotalTermElementDetailViewSummaryPage();
  const { clientID } = useClientContext();
  const location = useLocation();
  const parentPath = location.pathname.split('/').slice(0, -1).join('/');
  const quarterlyProgressReportReturnTo = getSafeQuarterlyProgressReportReturnTo({
    clientID,
    returnTo: new URLSearchParams(location.search).get('returnTo'),
  });
  const exit =
    parentPath && quarterlyProgressReportReturnTo
      ? appendQuarterlyProgressReportReturnTo(parentPath, quarterlyProgressReportReturnTo)
      : undefined;

  return (
    <>
      <SideOverHeaderNew
        exit={exit}
        exitIcon="back"
        className="!px-4"
        exitText={tCommon('back')}
        withShadow={withHeaderShadow}
      />
      <div className="px-6 sm:px-10 h-[calc(100%_-_70px)]">
        <SideOverHeading className="md:!mt-[25px]" heading={heading} />
        <div className="peer/sumTable">{children}</div>
        <div className="empty peer-empty/sumTable:flex hidden justify-between flex-col pb-[125px] h-[inherit]">
          <p className="text-lg leading-6 mt-3">{emptyDescription}</p>
          <EmptyDebtIllustration className="text-palette-600 mx-auto" />
        </div>
      </div>
    </>
  );
}
